import { callApi } from '../../../../../../../apiCaller';
import { API_SYSTEM_ADMIN_ORDER_INDIVIDUAL_DETAIL } from '../../../../../../../constants';
import { toastError } from '../../../../../../../utils';

export const ADD_ADMIN_ORDER_INDIVIDUAL = 'addAdminOrderIndividual';

export const addAdminOrderIndividual = (order) => {
     return {
          type: ADD_ADMIN_ORDER_INDIVIDUAL,
          payload: order,
     };
};

export const fetchAdminOrderIndividualRequest = (userId) => async (dispatch) => {
     return await callApi(API_SYSTEM_ADMIN_ORDER_INDIVIDUAL_DETAIL.replace(':id', userId), 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          dispatch(
               addAdminOrderIndividual(
                    response.data.map((el) => ({
                         ...el,
                         userEmail: el.user?.email || '',
                         organizationName: el.organization?.name,
                    }))
               )
          );
          return response.data;
     });
};
